import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';

import StackMapActions from '../actions/StackMapActions';
import { StackmapOverlay } from '@bibliocommons/stackmap';
import { currentLibrarySelector } from '../selectors/LibrarySelector';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import BCGoogleAnalyticsUtils from '@bibliocommons/utils-google-analytics';

class StackMapContainer extends BcReactComponent {
  componentDidUpdate(prevProps) {
    if (!this.props.isFetching && prevProps.isFetching) {
      BCGoogleAnalyticsUtils.event({
        eventCategory: 'stack-map',
        eventAction: 'map-found',
        eventLabel: this.props.callno,
        eventValue: this.props.noResults ? 0 : 1
      }, true);
    }
  }

  render() {
    return this.props.open ? <StackmapOverlay {...this.props} /> : null;
  }
}

StackMapContainer.propTypes = {
  open: PropTypes.bool,
  hideRanges: PropTypes.bool
};

const mapStateToProps = (state) => {
  const library = currentLibrarySelector(state);

  return {
    noResults: state.getIn(['ui', 'stackmap', 'noResults']),
    isFetching: state.getIn(['ui', 'stackmap', 'isFetching']),
    open: state.getIn(['ui', 'stackmap', 'open']),
    domain: library.getIn(['stackMap', 'domain']),
    hideRanges: library.getIn(['stackMap', 'hideRanges']),
    ...(state.getIn(['ui', 'stackmap', 'data']) || Immutable.Map()).toObject()
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(StackMapActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(StackMapContainer);



// WEBPACK FOOTER //
// ./app/containers/StackMapContainer.jsx